import React from "react";

export default function NextStepsVoiceAssistantPanel({
  isEnabled,
  isConnecting,
  isActive,
  error,
  displayPrompt,
  assistantTranscript,
  remoteAudioRef,
  onEnable,
  onDisable
}) {
  return (
    <div
      style={{
        background: "linear-gradient(135deg, rgba(6, 182, 212, 0.22), rgba(14, 165, 233, 0.16))",
        border: "1px solid rgba(125, 211, 252, 0.35)",
        borderRadius: 12,
        padding: "14px 16px",
        display: "flex",
        flexDirection: "column",
        gap: 10
      }}
    >
      <audio ref={remoteAudioRef} autoPlay playsInline style={{ display: "none" }} />

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#e0f2fe" }}>Voice Assistant</div>
        {isEnabled ? (
          <button
            onClick={onDisable}
            style={{
              background: "#1f2937",
              color: "#e5e7eb",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: 8,
              padding: "8px 12px",
              fontWeight: 700,
              cursor: "pointer"
            }}
          >
            Disable
          </button>
        ) : (
          <button
            onClick={onEnable}
            disabled={isConnecting}
            style={{
              background: isConnecting ? "#64748b" : "#10b981",
              color: "#052e16",
              border: "none",
              borderRadius: 8,
              padding: "8px 12px",
              fontWeight: 800,
              cursor: isConnecting ? "default" : "pointer",
              opacity: isConnecting ? 0.7 : 1
            }}
          >
            {isConnecting ? "Starting..." : "Enable"}
          </button>
        )}
      </div>

      {(isEnabled || isConnecting || error) && (
        <>
          <div style={{ fontSize: 13, color: "#bae6fd" }}>
            Status:{" "}
            {isConnecting ? "Connecting" : isActive ? "Active" : error ? "Error" : "Idle"}
          </div>

          {!!displayPrompt && (
            <div
              style={{
                fontSize: 14,
                lineHeight: 1.45,
                color: "#e2e8f0",
                background: "rgba(2, 6, 23, 0.38)",
                borderRadius: 10,
                padding: "10px 12px"
              }}
            >
              {displayPrompt}
            </div>
          )}

          {!!assistantTranscript && (
            <div
              style={{
                fontSize: 13,
                lineHeight: 1.45,
                color: "#e2e8f0",
                background: "rgba(2, 6, 23, 0.34)",
                borderRadius: 10,
                padding: "10px 12px"
              }}
            >
              <strong style={{ color: "#7dd3fc" }}>Assistant:</strong> {assistantTranscript}
            </div>
          )}

          {!!error && (
            <div
              style={{
                fontSize: 13,
                color: "#fecaca",
                background: "rgba(127, 29, 29, 0.35)",
                border: "1px solid rgba(252, 165, 165, 0.35)",
                borderRadius: 10,
                padding: "8px 10px"
              }}
            >
              {error}
            </div>
          )}
        </>
      )}
    </div>
  );
}
